import React, { useState, useRef } from "react";

const DiscoverAvdmButton = () => {
    const [deviceInfo, setDeviceInfo] = useState("");
    const [isDiscovering, setIsDiscovering] = useState(false);
    const statusLabelRef = useRef(null);
    const ddlAVDMRef = useRef(null);
    const finalUrlRef = useRef("");

    const discoverAvdm = async () => {
        if (isDiscovering) return;
        setIsDiscovering(true);
        let successFlag = 0;
        let primaryUrl = window.location.protocol === "https:" ? "https://127.0.0.1:" : "http://127.0.0.1:";

        if (ddlAVDMRef.current) ddlAVDMRef.current.innerHTML = "";

        for (let i = 11100; i <= 11120; i++) {
            try {
                const response = await fetch(primaryUrl + i.toString(), {
                    method: "RDSERVICE",
                    mode: "cors",
                    headers: { "Content-Type": "text/xml; charset=utf-8" },
                });

                if (!response.ok) continue;

                const data = await response.text();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(data, "text/xml");

                const status = xmlDoc.querySelector("RDService")?.getAttribute("status");
                const info = xmlDoc.querySelector("RDService")?.getAttribute("info");

                if (info?.includes("Mantra")) {
                    setDeviceInfo(data);
                    finalUrlRef.current = primaryUrl + i;

                    if (ddlAVDMRef.current) {
                        const option = document.createElement("option");
                        option.value = i.toString();
                        option.textContent = `(${status}) ${info}`;
                        ddlAVDMRef.current.appendChild(option);
                    }
                    successFlag = 1;
                    alert("RDSERVICE Discovered Successfully");
                    break;
                }
            } catch (error) {
                console.error("Error discovering AVDM:", error);
            }
        }

        if (successFlag === 0) {
            alert("Connection failed. Please try again.");
        }

        setIsDiscovering(false);
    };

    const deviceInfoAvdm = async () => {
        if (!finalUrlRef.current) {
            alert("Please discover AVDM first.");
            return;
        }

        try {
            const response = await fetch(finalUrlRef.current, {
                method: "DEVICEINFO",
                mode: "cors",
                headers: { "Content-Type": "text/xml; charset=utf-8" },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.text();
            setDeviceInfo(data);
        } catch (error) {
            console.error("Error fetching device info:", error);
            alert("Failed to fetch device info. Please try again.");
        }
    };

    const captureAvdm = async () => {
        if (!finalUrlRef.current) {
            alert("Please discover AVDM first.");
            return;
        }

        const captureUrl = `${finalUrlRef.current}/rd/capture`;

        const XML = `<?xml version="1.0"?>
            <PidOptions ver="1.0">
                <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000"  posh="UNKNOWN" env="P" />
                <CustOpts>
                    <Param name="mantrakey" value="SOME_KEY_VALUE" />
                </CustOpts>
            </PidOptions>`;

        try {
            const response = await fetch(captureUrl, {
                method: "CAPTURE",
                headers: {
                    "Content-Type": "text/xml; charset=utf-8",
                },
                body: XML,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.text();
            alert("Capture Successful: " + data);
            console.log("Capture Successful: ", data);

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, "text/xml");

            const resp = xmlDoc.getElementsByTagName('Resp')[0];
            const deviceInfo = xmlDoc.getElementsByTagName('DeviceInfo')[0];
            const additionalInfo = deviceInfo.getElementsByTagName('additional_info')[0];
            const skey = xmlDoc.getElementsByTagName('Skey')[0];
            const pidDataElement = xmlDoc.getElementsByTagName('Data')[0];

            // Extract skeydata and ci
            const skeydata = skey.textContent;  // Extract __text
            const ci = skey.getAttribute('ci'); // Extract _ci

            // Extract piddata and pidtype
            const piddata = pidDataElement.textContent;
            const pidtype = pidDataElement.getAttribute('type');

            // Extract additional parameters
            const parameters = [];
            const params = additionalInfo.getElementsByTagName('Param');
            for (let i = 0; i < params.length; i++) {
                const paramName = params[i].getAttribute('name');
                const paramValue = params[i].getAttribute('value');
                parameters.push({ name: paramName, value: paramValue });
            }

            const extractedData = {
                resp: {
                    errCode: resp.getAttribute('errCode'),
                    errInfo: resp.getAttribute('errInfo'),
                    fCount: resp.getAttribute('fCount'),
                    fType: resp.getAttribute('fType'),
                    nmPoints: resp.getAttribute('nmPoints'),
                    qScore: resp.getAttribute('qScore')
                },
                deviceInfo: {
                    dpId: deviceInfo.getAttribute('dpId'),
                    rdsId: deviceInfo.getAttribute('rdsId'),
                    rdsVer: deviceInfo.getAttribute('rdsVer'),
                    mi: deviceInfo.getAttribute('mi'),
                    mc: deviceInfo.getAttribute('mc'),
                    dc: deviceInfo.getAttribute('dc')
                },
                additionalInfo: parameters,
                ci: ci,
                skeydata: skeydata, // Updated skey extraction
                hmac: xmlDoc.getElementsByTagName('Hmac')[0].textContent,
                piddata: piddata,
                pidtype: pidtype
            };

            console.log(extractedData);
        } catch (error) {
            console.error("Error capturing data:", error);
            alert("Failed to capture data. Please try again.");
        }
    };

    return (
        <div style={{ marginTop: "20%" }}>
            <button className="btn btn-primary btn-200" onClick={discoverAvdm} disabled={isDiscovering}>
                {isDiscovering ? "Discovering..." : "Discover AVDM"}
            </button>
            <button className="btn btn-primary btn-200" onClick={deviceInfoAvdm} disabled={isDiscovering}>
                {isDiscovering ? "Discovering..." : "Device Info"}
            </button>
            <button className="btn btn-primary btn-200" onClick={captureAvdm} disabled={isDiscovering}>
                {isDiscovering ? "Discovering..." : "Capture"}
            </button>
            <p ref={statusLabelRef}>Status: Waiting...</p>
            <select ref={ddlAVDMRef}>
                <option value="">Select AVDM</option>
            </select>
            <textarea value={deviceInfo} readOnly rows="4" cols="50" />
        </div>
    );
};

export default DiscoverAvdmButton;